import LoginComponent from '@/components/login-component';
import { useTranslations } from 'next-intl';

const SignUp = () => {
  const t = useTranslations('Pages.SignUp');
  return <LoginComponent title={t('create_new_account')} view="sign_up" />;
};

export default SignUp;
